export default __webpack_public_path__ + "static/media/Exterior (18).2a84925a.jpg";